import { useInteractionToolsConfigUpdater } from '@vimeo/live-core/tracking/hooks';

import { SimpleNotifications } from '../../../shared/general/SimpleNotifications';
import { InteractionToolsAmbientEmbedSignaling } from './InteractionToolsAmbientEmbedSignaling';
import { InteractionToolsResponsiveScaling } from './InteractionToolsResponsiveScaling';

/**
 * Ambient component to manage globals in interaction tools.
 */
export function InteractionToolsAmbient() {
  useInteractionToolsConfigUpdater();

  return (
    <>
      <InteractionToolsResponsiveScaling />
      <InteractionToolsAmbientEmbedSignaling />
      <SimpleNotifications />
    </>
  );
}
